"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedProducts2 = exports.RECOMMENDED_PRODUCTS_2_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const RecommendedProducts2View_1 = require("./views2/RecommendedProducts2View");
exports.RECOMMENDED_PRODUCTS_2_SELECT = {
    id: true,
    slug: true,
    title: true,
    images: true,
    category: {
        title: true,
    },
    price: {
        price: true,
        currency: true,
        otherPrices: true,
        discountedPrice: true,
        regularPrice: true,
        lowestPriceBeforeSale: true,
    },
};
function RecommendedProducts2({ take = 6, ids, select, carouselProps, }) {
    const { data } = (0, app_1.useQuery)('getProducts', {
        args: Object.assign(Object.assign(Object.assign({}, (take && { take })), (ids && { ids })), { sort: {
                by: 'orderIndex',
                order: 'asc',
            } }),
        select: Object.assign(Object.assign({}, exports.RECOMMENDED_PRODUCTS_2_SELECT), select),
    });
    return ((0, jsx_runtime_1.jsx)(RecommendedProducts2View_1.RecommendedProducts2View, { products: data !== null && data !== void 0 ? data : [], carouselProps: carouselProps }));
}
exports.RecommendedProducts2 = RecommendedProducts2;
